import { Controller } from "@hotwired/stimulus"

// Manages the chat two-column layout on mobile screens.
// On small screens, toggles between the chat list (sidebar) and the conversation view.
export default class extends Controller {
  static targets = ["sidebar", "conversation"]

  connect() {
    this.mediaQuery = window.matchMedia("(max-width: 767px)")
    this.handleResize = this.handleResize.bind(this)
    this.mediaQuery.addEventListener("change", this.handleResize)

    // Show conversation immediately when a chat link is clicked on mobile
    this.element.addEventListener("click", this.trackChatClick.bind(this))

    // If page loaded with a chat_id param on mobile, show conversation
    if (this.mediaQuery.matches && new URLSearchParams(window.location.search).has("chat_id")) {
      this.showConversation()
    }
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleResize)
  }

  handleResize() {
    if (!this.mediaQuery.matches) {
      this.element.classList.remove("chat-open")
    }
  }

  trackChatClick(event) {
    const link = event.target.closest('a[data-turbo-frame="recent-messages"]')
    if (!link) return

    // Highlight the active chat in the sidebar
    this.element.querySelectorAll(".chat-list-item.active").forEach(el => {
      el.classList.remove("active")
    })
    link.classList.add("active")
    // Remove unread styling from the clicked chat
    link.classList.remove("chat-list-item-unread")

    // On mobile, show the conversation panel
    if (this.mediaQuery.matches) {
      this.showConversation()
    }
  }

  showConversation() {
    this.element.classList.add("chat-open")
  }

  showList() {
    this.element.classList.remove("chat-open")
  }
}
